import classnames from "classnames";
import "./style.css";
interface IButtonProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: () => void;
}
const Button: React.FC<IButtonProps> = ({ className, children, onClick }) => {
  return (
    <div
      className={classnames(
        "btn-hover-overlay flex cursor-pointer items-center justify-center rounded-[8px]",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Button;
